import { PhotoProvider, PhotoSlider, PhotoView } from "react-photo-view";
import "react-photo-view/dist/react-photo-view.css";
import { StringUtils } from "../../../../../core/utils/string_utils";

export const AvatarGalleryImageViewerComponent = ({ mediaItems, showImageViewer, viewerImageIndex, onClose, onIndexChange }) => {
  return (
    <>
      {/* Multiple Images Viewer */}
      <PhotoSlider
        visible={showImageViewer}
        images={mediaItems.map((item, index) => ({
          src: item.fileUrl,
          key: index - StringUtils.generateRandomCharacters(),
        }))}
        onClose={onClose}
        index={viewerImageIndex}
        onIndexChange={onIndexChange}
      />
    </>
  );
};
